export const PRODUCT_TAG = {
  New: 'new',
  Popular: 'bestseller',
  Sale: 'on-sale',
  Bware: 'bware',
  TopRated: 'topRated',
  BlackFriday: 'campaign:black_week',
  CyberWeek: 'campaign:cyber_week',
  CustomBadge: 'campaign:50%_boost',
} as const;
export type ProductTag = typeof PRODUCT_TAG[keyof typeof PRODUCT_TAG] | string;
